function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_18200",
  "data-name": "Group 18200",
  transform: "translate(-151.795 -483.501)"
}, React.createElement("rect", {
  id: "Rectangle_76574",
  "data-name": "Rectangle 76574",
  width: 18.115,
  height: 3.916,
  rx: 1,
  transform: "translate(151.795 489.939)"
}), React.createElement("rect", {
  id: "Rectangle_76575",
  "data-name": "Rectangle 76575",
  width: 18.115,
  height: 3.916,
  rx: 1,
  transform: "translate(151.795 496.078)"
}), React.createElement("path", {
  id: "Path_22216",
  "data-name": "Path 22216",
  d: "M8450.511,223.185,8448.6,226.5a.52.52,0,0,0,.45.781h3.827a.521.521,0,0,0,.451-.781l-1.914-3.314A.52.52,0,0,0,8450.511,223.185Z",
  transform: "translate(-8290.187 260.576)"
}), React.createElement("path", {
  id: "Path_22217",
  "data-name": "Path 22217",
  d: "M8451.412,479.19l1.914-3.314a.52.52,0,0,0-.451-.781h-3.827a.52.52,0,0,0-.45.781l1.913,3.314A.52.52,0,0,0,8451.412,479.19Z",
  transform: "translate(-8290.187 27.051)"
}));

var SvgReorder = function SvgReorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.115,
    height: 23,
    viewBox: "0 0 18.115 23",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Reorder.73d74a68.svg";
export { ForwardRef as ReactComponent };